import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.3337 11.3334H11.3337V19.3334H8.66699V11.3334H0.666992V8.66671H8.66699V0.666708H11.3337V8.66671H19.3337V11.3334Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
